import {
  FETCH_CARE_PLAN_EQUIPMENT,
  FETCH_CARE_PLAN_EQUIPMENT_SUCCESS,
  FETCH_CARE_PLAN_EQUIPMENT_FAILURE,
  FETCH_ACTIVE_EQUIPMENT_REGISTER,
  FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS,
  FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS,
  FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE,
  ADD_CARE_PLAN_EQUIPMENT,
  ADD_CARE_PLAN_EQUIPMENT_SUCCESS,
  ADD_CARE_PLAN_EQUIPMENT_FAILURE,
  EDIT_CARE_PLAN_EQUIPMENT,
  EDIT_CARE_PLAN_EQUIPMENT_SUCCESS,
  EDIT_CARE_PLAN_EQUIPMENT_FAILURE,
  DELETE_CARE_PLAN_EQUIPMENT,
  DELETE_CARE_PLAN_EQUIPMENT_SUCCESS,
  DELETE_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS,
  MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE,
} from "./constants";

export const fetchCarePlanEquipment = (payload, onSuccess) => ({
  type: FETCH_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const fetchCarePlanEquipmentSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const fetchCarePlanEquipmentFailure = () => ({
  type: FETCH_CARE_PLAN_EQUIPMENT_FAILURE,
});

// Resident-wide ACTIVE register snapshot (dedup hints) — parallel slice that
// never touches the paginated `equipment` key.
export const fetchActiveEquipmentRegister = (residentId, onSuccess) => ({
  type: FETCH_ACTIVE_EQUIPMENT_REGISTER,
  residentId,
  onSuccess,
});
export const fetchActiveEquipmentRegisterSuccess = (payload) => ({
  type: FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS,
  payload,
});
export const fetchActiveEquipmentRegisterFailure = () => ({
  type: FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE,
});

export const fetchCarePlanEquipmentCatalogue = (payload, onSuccess) => ({
  type: FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE,
  payload,
  onSuccess,
});
export const fetchCarePlanEquipmentCatalogueSuccess = (payload) => ({
  type: FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS,
  payload,
});
export const fetchCarePlanEquipmentCatalogueFailure = () => ({
  type: FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE,
});

export const addCarePlanEquipment = (payload, onSuccess) => ({
  type: ADD_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const addCarePlanEquipmentSuccess = (payload) => ({
  type: ADD_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const addCarePlanEquipmentFailure = () => ({
  type: ADD_CARE_PLAN_EQUIPMENT_FAILURE,
});

export const editCarePlanEquipment = (payload, onSuccess) => ({
  type: EDIT_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const editCarePlanEquipmentSuccess = (payload) => ({
  type: EDIT_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const editCarePlanEquipmentFailure = () => ({
  type: EDIT_CARE_PLAN_EQUIPMENT_FAILURE,
});

export const deleteCarePlanEquipment = (payload, onSuccess) => ({
  type: DELETE_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const deleteCarePlanEquipmentSuccess = (payload) => ({
  type: DELETE_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const deleteCarePlanEquipmentFailure = () => ({
  type: DELETE_CARE_PLAN_EQUIPMENT_FAILURE,
});

export const markProvidedCarePlanEquipment = (payload, onSuccess) => ({
  type: MARK_PROVIDED_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const markProvidedCarePlanEquipmentSuccess = (payload) => ({
  type: MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const markProvidedCarePlanEquipmentFailure = () => ({
  type: MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE,
});

export const markDiscontinuedCarePlanEquipment = (payload, onSuccess) => ({
  type: MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const markDiscontinuedCarePlanEquipmentSuccess = (payload) => ({
  type: MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const markDiscontinuedCarePlanEquipmentFailure = () => ({
  type: MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE,
});

export const markReplacedCarePlanEquipment = (payload, onSuccess) => ({
  type: MARK_REPLACED_CARE_PLAN_EQUIPMENT,
  payload,
  onSuccess,
});
export const markReplacedCarePlanEquipmentSuccess = (payload) => ({
  type: MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS,
  payload,
});
export const markReplacedCarePlanEquipmentFailure = () => ({
  type: MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE,
});
